/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons/faAngleDoubleLeft'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactElement } from 'react'
import { usePaginationContext } from './PaginationProvider'
import { Button, ButtonGroup, ButtonGroupProps, ButtonProps } from '@mantine/core'

export type PaginationNavProps = ButtonGroupProps & {
  buttonProps?: ButtonProps
}

function PaginationNav (props: PaginationNavProps): ReactElement {
  const { buttonProps, ...others } = props

  const {
    first,
    hasNext,
    hasPrevious,
    last,
    next,
    previous
  } = usePaginationContext()

  return (
    <ButtonGroup {...others}>
      <Button
        px="xs"
        {...buttonProps}
        disabled={!hasPrevious}
        onClick={first}
      >
        <FontAwesomeIcon fixedWidth icon={faAngleDoubleLeft} />
      </Button>
      <Button
        px="xs"
        {...buttonProps}
        disabled={!hasPrevious}
        onClick={previous}
      >
        <FontAwesomeIcon fixedWidth icon={faAngleLeft} />
      </Button>
      <Button
        px="xs"
        {...buttonProps}
        disabled={!hasNext}
        onClick={next}
      >
        <FontAwesomeIcon fixedWidth icon={faAngleRight} />
      </Button>
      <Button
        px="xs"
        {...buttonProps}
        disabled={!hasNext}
        onClick={last}
      >
        <FontAwesomeIcon fixedWidth icon={faAngleDoubleRight} />
      </Button>
    </ButtonGroup>
  )
}

export default PaginationNav
